import React from "react"
import Link from 'gatsby-link'
import SbEditable from 'storyblok-react'
import Logo from "static/logo_secondary.svg"
import FooterWave from "static/footer_wave.svg"
import FooterWaveMobile from "static/footer_wave_mobile.svg"
import { useIdentityContext } from 'react-netlify-identity-gotrue'
import resolveLink from 'src/utils/resolveLink'

const Footer = ({ settings }) => {

  const identity = useIdentityContext()
    
  return (
    <footer className="bg-midnight text-white overflow-hidden relative"> 
        <div className="relative max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">    
            <div className="flex py-4">
                <div className="mr-right"><img src={Logo} alt="Generation Media Logo" className="w-56"/></div>
            </div>     
        <div className="">
            {/* <!-- contact details --> */}
            <div className="py-5 footer-text">   
                <div class="mb-1">Global Head Office.</div>      
                <div>7-8 Midford Place, London W1T 5BG   </div>  
            </div>
            <div class="mb-1">
                <a href="tel:02073077900" className="footer-text text-orange hover:text-white duration-300">           
                    <span className="text-orange">T:</span> +44 (0) 207 307 7900               
                </a>
            </div>
            <div>
                <a href="mailto:contact@generationmedia.co.uk" className="footer-text text-orange hover:text-white duration-300">           
                    <span className="text-orange">E:</span> contact@generationmedia.co.uk         
                </a>
            </div>  
            {/* <!-- Socials --> */}     
            <div className="flex mt-5 gap-x-4">
                <div className="">
                    <a href="https://www.tiktok.com/@generationmedia" className="group" target="_blank" rel="noreferrer">
                        <i className="fab fa-tiktok duration-300 group-hover:text-orange"></i>
                    </a>
                </div>
                <div className="w-4 h-4">
                    <a href="https://www.linkedin.com/company/generation-media/" className="group" target="_blank" rel="noreferrer">
                        <i className="fab fa-linkedin duration-300 group-hover:text-orange"></i> 
                    </a>
                </div>
                <div className="">
                    <a href="https://www.instagram.com/generat10n_media/" className="group" target="_blank" rel="noreferrer">
                        <i className="fab fa-instagram duration-300 group-hover:text-orange"></i>
                    </a>
                </div>
            </div>
        </div>
        <div className="block md:flex items-end w-full">
            <div className="small-footer-text mr-auto text-left py-2">
                <p className="mt-8">
                    Copyright ©  Generation Media Ltd 2025.
                </p> 
                <p>
                    Registered in England No: 04342267
                </p>
            </div>
            <div className="ml-auto py-2 text-left small-footer-text">
                <p className="mt-0 sm:mt-8">Website by <a className="text-orange hover:brightness-75 duration-300" href="https://www.thebiggerboat.co.uk">The Bigger Boat</a></p>
            </div>
        </div>      
      </div>
    </footer>
  )
}

export default Footer
